const exchangeCurrency = (props) => {
  const { defaultCurrencyISO, isMultiCurrencyEnabled, oldCurrencyISO, price } =
    props;
  if (!price) return;
  if (!isMultiCurrencyEnabled) return price;

  const newCurrencyISO = Currency.cookie.read() || defaultCurrencyISO;
  return Currency.convertPrice(price, oldCurrencyISO, newCurrencyISO);
};

const getDisplayCurrencyIso = (defaultCurrencyISO = '') =>
  Currency.cookie.read() || defaultCurrencyISO;

export default {
  exchangeCurrency,
  getDisplayCurrencyIso,
};
